import { ProfileActionTypes, ProfileActions } from './profile.actions';
import { IExternalData } from '../../../commons';

export interface State {
    error: string | null;
    success: string | null;
    pending: boolean;
    stateData: IExternalData | null;
}

export const initialState: State = {
    error: null,
    success: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: ProfileActions): State {
    switch (action.type) {

        case ProfileActionTypes.LoadProfileState: {
            return {
                ...state,
                error: null,
                success: null,
                pending: true
            };
        }

        case ProfileActionTypes.LoadProfileStateSuccess: {
            return {
                ...state,
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case ProfileActionTypes.VerifyEIN:
        case ProfileActionTypes.SetPassword:
        case ProfileActionTypes.SubmitProfileDetail: {
            return {
                ...state,
                pending: true
            }
        }

        case ProfileActionTypes.SetPasswordSuccess: {
            return {
                ...state,
                success: state.success === null ? action.payload : state.success,
                pending: false
            }
        }
        case ProfileActionTypes.SubmitProfileDetailSuccess: {
            return {
                ...state,
                success: state.success === null ? action.payload : state.success,
                pending: false
            }
        }


        case ProfileActionTypes.VerifyEINSuccess: {
            return {
                ...state,
                success: state.success === null ? action.payload : state.success
            }
        }

        case ProfileActionTypes.LoadProfileStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case ProfileActionTypes.ProfileScreenErrorReset: {
            return {
                ...state,
                error: null,
                success: null,
                pending: false
            };
        }

        case ProfileActionTypes.LoadInitState: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;
export const getSuccessMessage = (state: State) => state.success;